module.exports = __webpack_public_path__ + "img/assistencia-medica.69922da3.png";